import { Fragment } from 'react';

import { EMAIL } from 'utils/constants/contacts';
import copyLink from 'utils/copy';

import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';
import Gap from 'bloko/blocks/gap';
import { H1Section } from 'bloko/blocks/header';
import Link, { LinkAppearance } from 'bloko/blocks/link';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import 'pages/ServerError/ServerError.less';

import { Header } from 'components/Header/Header';

import { useSelector } from 'store/utils';

const ServerError = () => {
    const xRequestId = useSelector((state) => state.xRequestId);

    const trl = useTrls();

    const errorCode = trl('serverError.code', [xRequestId]);

    return (
        <Fragment>
            <Header />
            <ColumnsWrapper>
                <ColumnsRow>
                    <Column xs="4" s="8" m="12" l="16">
                        <Gap top bottom>
                            <H1Section>{trl('serverError.title')}</H1Section>
                            <VSpacing base={8} />
                            <p className="server-error__item">{trl('serverError.part1')}</p>
                            <p className="server-error__item">
                                {trl('serverError.part2', [xRequestId])}
                                <Link href={`mailto:${EMAIL}?subject=${trl('serverError.title')}&body=${errorCode}`}>
                                    {EMAIL}
                                </Link>
                            </p>
                            <p className="server-error__item">
                                <Link appearance={LinkAppearance.Pseudo} onClick={() => copyLink(errorCode)}>
                                    {trl('serverError.copy')}
                                </Link>
                            </p>
                        </Gap>
                    </Column>
                </ColumnsRow>
            </ColumnsWrapper>
        </Fragment>
    );
};

export default ServerError;
